import { Box, Button, Grid } from '@mui/material';
import RecordType from '../../Models/Locations/recordType';
import { greyLightContainer } from '../../assets/styles/appStyles';
import GenericInput from '../AddLocation/Components/UI/GenericInput';
import { AssociationDetailsViewModel } from '../../Models/Association/association-details-viewmodels';
import AssociationForm from './AddAssociations/AssociationForm';

export default function AssociationsListToBeAdded({
  recordTypes,
  providers,
  removeAssociation,
  formKeyName,
  form,
  setAssociationData,
  associationData
}: {
  recordTypes: RecordType[];
  providers: any[];
  removeAssociation: (id: number) => void;
  formKeyName: string;
  form: any;
  setAssociationData: any
  associationData: AssociationDetailsViewModel;
}) {
  return (
    <Box>
      {associationData?.entityAssociations?.map((item: any, index: number) => (
        <Box key={index} sx={greyLightContainer} mb={2} p={2}>
          <Grid container>
            <Grid item xs={2} px={1}>
              <GenericInput
                name="name"
                label="Custodian Name"
                placeholder="Custodian Name"
                maxLength={120}
                value={item.childEntityName}
                onChange={() => { }}
                errorMsg={''}
                hasError={false}
                onBlur={() => { }}
                disabled={true}
              />
              {(item?.id === 0 || item?.id === undefined)&& 
              <Button
                onClick={() => {
                  removeAssociation(item.childEntityId);
                }}
              >
                Delete
              </Button>}
            </Grid>
            <AssociationForm
              setAssociationData={setAssociationData}
              associationData={associationData}
              recordTypes={recordTypes}
              providers={providers}
              associationIndex={index}
              form={form}
              formKeyName={formKeyName}
            />
          </Grid>
        </Box>
      ))}
    </Box>
  );
}
